import { TGraphicDesignLessonConfig } from '../../../models/courses/graphicDesign';
import { TConfigIssue } from './validateConfig';

export type TAdminStep = 'essentials' | 'start' | 'solution' | 'rules' | 'zones'
  | 'versions' | 'help';
const allSteps: TAdminStep[] = ['essentials', 'start', 'solution', 'rules', 'zones',
  'versions', 'help'];
export const isIntentRead = (config: TGraphicDesignLessonConfig): boolean =>
  config.exerciseType === 'INTENT' && (config.versions?.length ?? 0) > 0;
export const adminSteps = (config: TGraphicDesignLessonConfig): TAdminStep[] => {
  switch (config.exerciseType) {
    case 'CREATE': case 'TRANSFORM':
      return ['essentials', 'start', 'solution', 'rules', 'help'];
    case 'INTENT':
      return isIntentRead(config) ? ['essentials', 'versions', 'help']
        : ['essentials', 'solution', 'rules', 'help'];
    case 'CRITIQUE': return ['essentials', 'zones', 'help'];
    case 'CHOOSE': return ['essentials', 'versions', 'help'];
  }
};
export const issueStep = (issue: TConfigIssue, config: TGraphicDesignLessonConfig): TAdminStep => {
  const field = issue.field;
  let step: TAdminStep = 'essentials';
  if (field.startsWith('initialState')) step = 'start';
  else if (field.startsWith('solution')) step = 'solution';
  else if (field.startsWith('hints')) step = 'help';
  else if (field.startsWith('zones') || field.startsWith('backgroundImage')) step = 'zones';
  else if (field.startsWith('versions')) step = 'versions';
  else if (field.startsWith('requiredRules')) step = config.exerciseType === 'CRITIQUE'
    ? 'zones' : 'rules';
  else if (field.startsWith('rules')) step = config.exerciseType === 'CHOOSE' || isIntentRead(config)
    ? 'versions' : 'rules';
  return adminSteps(config).includes(step) ? step : 'essentials';
};
export const stepIssues = (issues: TConfigIssue[], config: TGraphicDesignLessonConfig):
  Record<TAdminStep, TConfigIssue[]> => {
  const result = {} as Record<TAdminStep, TConfigIssue[]>;
  allSteps.forEach(step => { result[step] = []; });
  issues.forEach(issue => result[issueStep(issue, config)].push(issue));
  return result;
};
